/**
 * Persists auth token + user in localStorage (browser and Capacitor WebView).
 * Capacitor’s WebView keeps the same origin storage across launches, so sessions
 * survive app restarts without a native plugin — avoids bundling @capacitor/preferences.
 * In-memory cache stays in sync so axios can read the token synchronously after hydrate.
 */

const KEY_TOKEN = 'token';
const KEY_USER = 'user';

let memoryToken = null;
let memoryUserJson = null;

function readFromStorage() {
  if (typeof localStorage === 'undefined') {
    return { token: null, userJson: null };
  }
  return {
    token: localStorage.getItem(KEY_TOKEN),
    userJson: localStorage.getItem(KEY_USER),
  };
}

/**
 * Load persisted session into memory. Call once before rendering the app.
 */
export async function hydrateAuthStorage() {
  const { token, userJson } = readFromStorage();
  memoryToken = token;
  memoryUserJson = userJson;
}

export function getTokenSync() {
  return memoryToken;
}

export function getUserJsonSync() {
  return memoryUserJson;
}

export async function setSession(token, userJson) {
  memoryToken = token;
  memoryUserJson = userJson;
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(KEY_TOKEN, token);
    localStorage.setItem(KEY_USER, userJson);
  }
}

export async function clearSession() {
  memoryToken = null;
  memoryUserJson = null;
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(KEY_TOKEN);
    localStorage.removeItem(KEY_USER);
  }
}
